/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PamPlayerSearchSummary } from './PamPlayerSearchSummary';
import {
    PamPlayerSearchSummaryFromJSON,
    PamPlayerSearchSummaryFromJSONTyped,
    PamPlayerSearchSummaryToJSON,
} from './PamPlayerSearchSummary';
import type { ResultRange } from './ResultRange';
import {
    ResultRangeFromJSON,
    ResultRangeFromJSONTyped,
    ResultRangeToJSON,
} from './ResultRange';
import type { PageSort } from './PageSort';
import {
    PageSortFromJSON,
    PageSortFromJSONTyped,
    PageSortToJSON,
} from './PageSort';

/**
 * 
 * @export
 * @interface PagePamPlayerSearchSummary
 */
export interface PagePamPlayerSearchSummary {
    /**
     * 
     * @type {Array<PamPlayerSearchSummary>}
     * @memberof PagePamPlayerSearchSummary
     */
    results: Array<PamPlayerSearchSummary>;
    /**
     * 
     * @type {number}
     * @memberof PagePamPlayerSearchSummary
     */
    totalResults: number;
    /**
     * 
     * @type {PageSort}
     * @memberof PagePamPlayerSearchSummary
     */
    sort: PageSort;
    /**
     * 
     * @type {ResultRange}
     * @memberof PagePamPlayerSearchSummary
     */
    resultRange: ResultRange;
}

/**
 * Check if a given object implements the PagePamPlayerSearchSummary interface.
 */
export function instanceOfPagePamPlayerSearchSummary(value: object): value is PagePamPlayerSearchSummary {
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('totalResults' in value) || value['totalResults'] === undefined) return false;
    if (!('sort' in value) || value['sort'] === undefined) return false;
    if (!('resultRange' in value) || value['resultRange'] === undefined) return false;
    return true;
}

export function PagePamPlayerSearchSummaryFromJSON(json: any): PagePamPlayerSearchSummary {
    return PagePamPlayerSearchSummaryFromJSONTyped(json, false);
}

export function PagePamPlayerSearchSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagePamPlayerSearchSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(PamPlayerSearchSummaryFromJSON)),
        'totalResults': json['totalResults'],
        'sort': PageSortFromJSON(json['sort']),
        'resultRange': ResultRangeFromJSON(json['resultRange']),
    };
}

export function PagePamPlayerSearchSummaryToJSON(value?: PagePamPlayerSearchSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'results': ((value['results'] as Array<any>).map(PamPlayerSearchSummaryToJSON)),
        'totalResults': value['totalResults'],
        'sort': PageSortToJSON(value['sort']),
        'resultRange': ResultRangeToJSON(value['resultRange']),
    };
}

